const OnboardingTestimonialCard = () => {
  return (
    <div className="rounded-2xl p-6 backdrop-blur-lg bg-white/5  font-semibold border-white/50 border flex flex-col gap-6 text-white text-3xl 2xl:text-4xl">
      <p className="p-0 m-0">
        “We’ve reduced incoming tickets by 90% and saved over $300,000 on annual
        support costs by switching to SupportMagic.
      </p>

      <p className="p-0 m-0">
        We can’t imagine working without it. It’s incredible.”
      </p>

      <div className="flex items-center gap-6 justify-between">
        <p className="p-0 m-0">Molly Archibald</p>
        <div className="flex gap-1 text-white text-2xl 2xl:text-3xl">
          <div>★</div>
          <div>★</div>
          <div>★</div>
          <div>★</div>
          <div>★</div>
        </div>
      </div>

      <div>
        <p className="p-0 m-0 text-xl">Head of Customer Experience, NuggMD</p>
        <p className="p-0 m-0 text-lg">Telehealth Platform</p>
      </div>
    </div>
  );
};

export default OnboardingTestimonialCard;
